module.exports = __webpack_public_path__ + "img/library_noImg.0ec2e6f8.jpg";